<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" offset-md="3">
        <form @submit.prevent="save">
          <v-text-field
            v-model="form.name"
            ref="nameField"
            label="Naziv *"
          ></v-text-field>
          <FormErrors
            v-if="$v.form.$error && (!$v.form.name.required || !$v.form.name.unique)"
          >
            <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
            <FormErrorsLine v-if="!$v.form.name.unique" text="Miza z istim imenom že obstaja" />
          </FormErrors>
          <v-select
            :items="localLocations"
            item-text="name"
            item-value="id"
            v-model="form.location"
            label="Prostor *"
          >
            <v-tooltip
              top
              slot="append-outer"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon small @click="showAddLocationModal = true" v-on="on">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </template>
              <span>Dodaj novo lokacijo</span>
            </v-tooltip>
          </v-select>
          <FormErrors
            v-if="$v.form.$error && (!$v.form.location.required)"
          >
            <FormErrorsLine v-if="!$v.form.location.required" text="Polje je obvezno" />
          </FormErrors>
          <v-row>
            <v-col style="max-width: fit-content;">
              <v-checkbox
                hide-details
                color="#0F998E"
                v-model="form.type"
                label="Ne prikazuj med odprtimi mizami"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                  :items="clientsWithNull"
                  item-text="name"
                  item-value="val"
                  v-model="form.client"
                  label="Izberi klienta"
                ></v-select>
            </v-col>
          </v-row>

          <v-btn type="submit" class="float-right">Shrani</v-btn>
          <v-btn v-if="isNewTable" type="button" class="float-right mr-4" @click="saveAndRepeat">Shrani in nov</v-btn>
          <v-btn text type="button" class="float-right mr-4" @click="emitClose ? $emit('cancel') : $router.go(-1)">Prekliči</v-btn>
        </form>
      </v-col>
    </v-row>
    <PopupAddLocation
      ref="addLocationModal"
      v-model="showAddLocationModal"
      @confirmed="addLocation"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import { objectToArray } from '@/utils/object'
import PopupAddLocation from '@/components/PopupAddLocation'
import { mapActions } from 'vuex'
import { siMatch } from '@/utils/str'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    PopupAddLocation
  },
  props: {
    table: {
      default: () => {},
      type: Object
    },
    locations: {
      required: true,
      type: Array
    },
    tables: {
      required: true,
      type: Array
    },
    emitClose: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localLocations: [],
      clientsWithNull: [],
      showAddLocationModal: false,
      emptyForm: {
        name: '',
        location: null,
        sort_order: null,
        type: 0
      },
      form: {}
    }
  },
  validations: {
    form: {
      name: {
        required,
        unique (val) {
          if (!val.length) return true
          const matchingTable = this.tables.filter(table => siMatch({ str1: table.name, str2: val }))
          return (Array.isArray(matchingTable) && matchingTable.length === 0) || (!this.isNewTable && matchingTable[0].id === this.table.id)
        }
      },
      location: {
        required
      }
    }
  },
  computed: {
    isNewTable () {
      return this.table ? Object.keys(this.table).length === 0 || !this.table.id : true
    },
    clients () {
      return objectToArray(this.$store.state.clients.items)
    },
  },
  methods: {
    ...mapActions('locations', { createNewLocation: 'saveItem' }),
    ...mapActions('clients', ['loadItems', 'deleteItem']),
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$emit('save', { data: this.form, repeat: true })
    },
    saveAndRepeatClear () {
      setTimeout(() => {
        this.form.name = ''
        this.$refs.nameField.focus()
      }, 50)
    },
    clearForm () {
      this.form = { ...this.emptyForm }
    },
    cancel () {
      this.$emit('cancel')
    },
    addLocation ({ data }) {
      this.createNewLocation({ ...data })
        .then(newLocation => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.showAddLocationModal = false
          this.$refs.addLocationModal.clearForm()
          this.localLocations.push(newLocation)
          this.form.location = newLocation.id
        })
    }
  },
  async created () {
    this.localLocations = this.locations
    this.form = { ...this.emptyForm }
    await this.loadItems(this)
    this.clientsWithNull.push({
      name: 'Brez klienta',
      val: null
    })
    this.clients.forEach(x => {
      this.clientsWithNull.push({
        name: x.name,
        val: x.id
      })
    })
    if (this.table) {
      this.form = { ...this.form, ...this.table }
    }
  }
}
</script>
